











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddOrgMutation_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removedSuggestedActionId",
      "storageKey": null
    }
  ],
  "type": "AddOrgPayload",
  "abstractKey": null
};

(node ).hash = "7698ca11a11e5b113bca39482b3abba7";

export default node;
